<template>
  <generic-modal
    :title="$t('sirc credit information case')"
    ref="generic_modal"
  >
    <div v-if="meta">
      <div class="columns is-multiline">
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.name" />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("promissory note number") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.promissory_note_number"
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("dpi") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.dpi" />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("nit") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.nit" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-play"></i>
        </span>
        <span>{{ $t("start process") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "SIRCCreditInformationModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.name ||
        !v.meta.dpi ||
        !v.meta.nit ||
        !v.meta.promissory_note_number
      );
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/factoring", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      put("/sirc-credit-information/case", v.meta)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        dpi: "",
        nit: "",
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
